<template>
  <div id="wrapper" class="noheader">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>木生婦幼診所</p>
          <span></span>
        </div>
      </div>
      <div class="surveyBox">
        <div class="title"><h2>初診基本資料單</h2></div>
        <p class="description">
          歡迎您蒞臨本院<br />請您詳細填寫下列基本資料<br />謝謝！
        </p>
        <div class="formBox">
          <form action="javascript:void(0);">
            <slot></slot>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
